var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61441 2.55599L14.3847 7.32629C14.5725 7.51114 14.665 7.75562 14.665 8.0001C14.665 8.24457 14.5718 8.48846 14.3855 8.6745L9.61515 13.4448C9.24247 13.8175 8.63873 13.8175 8.26605 13.4448C7.89337 13.0721 7.89337 12.4684 8.26605 12.0957L11.4092 8.95416L2.26219 8.95416C1.73477 8.95416 1.33496 8.52692 1.33496 8.02693C1.33496 7.52694 1.73477 7.04604 2.26219 7.04604L11.4092 7.04604L8.2668 3.9036C7.89412 3.53092 7.89412 2.92718 8.2668 2.5545C8.63948 2.18182 9.24173 2.18331 9.61441 2.55599Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.49c97e102a511186942bb848e55174fa.svg";
export { ForwardRef as ReactComponent };